import React from 'react'
import ProgressiveImage from 'react-progressive-image'

import Title from 'components/base/Title'
import Paragraph, { Theme as ParagraphTheme } from 'components/base/Paragraph'
import Link, { Theme as LinkTheme }  from 'components/base/Link'
import ButtonRow from 'components/base/Button/Row'

import GoldBgr from 'assets/images/backgrounds/bgr-gold.webp'
import GoldBgr64 from 'assets/images/backgrounds/bgr-gold-placeholder'

import TeamSlider from 'components/blocks/TeamSlider'

import {
  LeadershipSectionWrap,
  SubpageSection,
} from './styles'

const Leadership: React.FC = (): React.ReactElement => (
  <ProgressiveImage
    src={GoldBgr}
    placeholder={GoldBgr64}
  >
    {(src: string, loading: boolean): React.ReactElement => (
      <LeadershipSectionWrap img={src} isLoading={loading}>
        <SubpageSection>
          <Title level={2}>Meet our Leadership Team</Title>
          <Paragraph theme={ParagraphTheme.large}>
            Insurance Lounge is led by a group of capable leaders with backgrounds in technology, customer service, insurance sales, and management.
            Our founder and CEO, Michael DeLaGrange, has had a long career in the insurance agency, beginning with his experience at his father’s insurance brokerage in his hometown of Grants Pass, OR.
            Michael’s vision for a transparent insurance company with accessible policies was brought to life through Insurance Lounge’s premium online and storefront insurance services.
          </Paragraph>
          <TeamSlider />
          <ButtonRow>
            <Link theme={LinkTheme.button} to='/about-us/our-team/'>
              View Team Profiles
            </Link>
          </ButtonRow>
        </SubpageSection>
      </LeadershipSectionWrap>
    )}
  </ProgressiveImage>
)

export default Leadership
